var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 5.99984C7.47268 5.99984 8.66602 4.8065 8.66602 3.33317C8.66602 1.85984 7.47268 0.666504 5.99935 0.666504C4.52602 0.666504 3.33268 1.85984 3.33268 3.33317C3.33268 4.8065 4.52602 5.99984 5.99935 5.99984ZM5.99935 7.33317C4.21935 7.33317 0.666016 8.2265 0.666016 9.99984V10.6665C0.666016 11.0332 0.966016 11.3332 1.33268 11.3332H10.666C11.0327 11.3332 11.3327 11.0332 11.3327 10.6665V9.99984C11.3327 8.2265 7.77935 7.33317 5.99935 7.33317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.736bfd521022d14f80cac25126ecf767.svg";
export { ForwardRef as ReactComponent };